<template>
    <div>
        <div>
            <b>{{cartItem.quantity}}x {{product.name}} <template v-if="product.variant">&bull; {{product.variant.name}}</template></b>
            <br>
            <small id="components">{{defaultComponents}}</small>
        </div>
        <div class="components" v-if="showComponents">
            <div v-for="t in product.componentTypes" :key="t.id">
                <h5>{{t.name}}</h5>
                <div v-for="c in product.availableComponents.filter(x => x.type.id === t.id)" :key="c.id">
                    <template v-if="t.type === 'single-choice'">
                        <input type="radio" :name="'component-'+t.id" :checked="selectedComponents.indexOf(c) !== -1" @change="setSingleChoice(c,t)">
                    </template>
                    <template v-if="t.type === 'multiple-choice'">
                        <input type="checkbox" v-model="selectedComponents" :value="c">
                    </template>
                    <span>{{c.name}}</span><span v-if="c.price"> (+{{utils.euro(c.price)}})</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
export default {
    props: ["product", "cartItem"],
    data(){
        return {
            utils,
            showComponents: false,
            selectedComponents: this.product.availableComponents.filter(x => x.default)
        }
    },
    methods: {
        setSingleChoice(c,t){
            this.selectedComponents = this.selectedComponents.filter(x => x.type.id !== t.id);
            this.selectedComponents.push(c);
        },
        addToCart(){
            let input = {
                idProduct: this.product.id,
                quantity: 1,
                fields: {
                    components: this.selectedComponents.map(m => m.id)
                }
            }
            this.$store.dispatch('addToCart',input);
        }
    },
    computed:{
        defaultComponents(){
            return this.product.selectedComponents.map(m => m.name).join(",");
        }
    }
}
</script>
<style lang="scss" scoped>
#components {
    font-size: 10px;
}
</style>